const assert = require('assert');
const axios = require('axios');
const { errorMapper } = require('../ErrorMapper');

const CURRENT_VERSION = 'v1';

class OfferServiceConnector {
  constructor(configuration, tokenManager) {
    assert(configuration, 'configuration is required');
    this.httpClient = axios.create(configuration);

    this.tokenManager = tokenManager;
  }

  async getById({ offerId, bookingChannelId }) {
    try {
      const options = await this.getOptions();
      const { data } = await this.httpClient.get(`/${CURRENT_VERSION}/offers/${offerId}`, {
        params: {
          bookingChannelId,
        },
        ...options,
      });
      return data;
    } catch (error) {
      return this._handleError(error);
    }
  }

  async getOptions() {
    if (!this.tokenManager) {
      return {};
    }

    const token = await this.tokenManager.getToken();
    return {
      headers: {
        Authorization: `Bearer ${token.accessToken}`,
      },
    };
  }

  _handleError(error) {
    throw errorMapper(error);
  }
}

module.exports = {
  OfferServiceConnector,
};
